<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="d-flex align-items-end mb-md-0 mb-1">
          <b-form-checkbox
            :checked="includeArchived"
            @change="onToggleArchived"
          >
            Показывать архивные
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="4">
          <label>Минимум игр</label>
          <b-form-input
            type="number"
            min="0"
            max="1000"
            :value="minGames"
            :debounce="250"
            @update="onMinGamesUpdate"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormCheckbox, BFormInput,
} from 'bootstrap-vue'

const clamp = (value, min, max) => {
  if (value < min) return min
  if (value > max) return max
  return value
}

export default {
  components: {
    BCard, BCardBody, BRow, BCol, BFormCheckbox, BFormInput,
  },
  props: {
    includeArchived: { type: Boolean, default: false },
    minGames: { type: Number, default: 0 },
  },
  setup(_, { emit }) {
    const onToggleArchived = checked => {
      emit('update:include-archived', !!checked)
    }
    const onMinGamesUpdate = raw => {
      const parsed = Number.parseInt(raw, 10)
      const next = Number.isNaN(parsed) ? 0 : clamp(parsed, 0, 1000)
      emit('update:min-games', next)
    }
    return { onToggleArchived, onMinGamesUpdate }
  },
}
</script>
